import MenuNames from "../../../constants/Menu/MenuNames.json";

import CallDepartments from "../../../views/CallDepartments";

const CallDepartmentsRoutes = [
  {
    menuName: MenuNames.LOGISTICS_SUPPORT_DEPARTMENTS,
    path: "/call-departments",
    component: CallDepartments,
    exact: true,
  },
  {
    menuName: MenuNames.LOGISTICS_SUPPORT_DEPARTMENTS,
    path: "/call-departments/:id(\\d+)",
    component: CallDepartments,
    exact: true,
  },
];
export default CallDepartmentsRoutes;
